import React, { useState, useEffect, useRef, useMemo, useReducer } from "react";
import { Grid, Col, Row, Table, Modal, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import DeviceList from "components/Devices/DeviceList.jsx";
import SelectedDevice from "components/Devices/SelectedDevice.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import SearchBar from "components/SearchBar/SearchBar.jsx";
import Card from "components/Card/Card.jsx";
import MenuButton from "components/MenuButton/MenuButton.jsx";

import BrowserHistory from "models/BrowserHistory";
import DeviceMap from "components/Devices/DeviceMap";


const UserMgmt = ({ api }) => {
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const [usersInfo, setUsers] = useState({id: 0, managableUsers: [], uninit: true});
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newUserInfo, setNewUserInfo] = useState({});
  const [showLoading, setShowLoading] = useState(false);
  

  if(usersInfo.uninit) {
    usersInfo.uninit = false;
    setUsers(usersInfo);
    api.fetch_managable_users().then(setUsers);
  }

  function handleCreateUser(e) {
    e.preventDefault();
    setShowLoading(true);
    usersInfo.createUser(newUserInfo.email, newUserInfo.name, newUserInfo.orgId ? parseInt(newUserInfo.orgId) : usersInfo.orgs[0].id).then((res)=>{ 
      setShowLoading(false);
      if(res.success) {
        api.fetch_managable_users().then(setUsers);
        setShowCreateModal(false);
        setNewUserInfo({});
      } else {
        setNewUserInfo({...newUserInfo, warning: res.warning ?? "Something went wrong"});
      }
    }, (res)=>{
      setShowLoading(false);
      setNewUserInfo({...newUserInfo, warning: new String(res)});
    });
  }

  return (
    <div className="main-content">
        <Card
        content={
            <>
            { usersInfo.canCreateUsers ? (<button onClick={(e)=>setShowCreateModal(true)} style={{marginLeft: "5px", marginBottom: "5px"}}>Create User</button>) : ("") }
            <button onClick={(e)=>api.fetch_managable_users().then(setUsers)} style={{marginLeft: "5px", marginBottom: "5px"}}>Refresh</button>
            <Table bordered>
                <thead>
                    <tr>
                        <th>Id</th>
                        { usersInfo.showOrgs ? (<th>Org</th>) : ("") }
                        <th>Name</th>
                        <th>Email</th>
                        <th>Last Seen</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                {usersInfo.managableUsers.length === 0 ? (
                    <tr>
                        <td colSpan="5">
                            <small style={{ color: "white" }}>---</small>
                        </td>
                    </tr>
                ) : (
                    usersInfo.managableUsers.map((u) => (
                        <tr key={u.id}>
                        <td>{u.id}</td>
                        { usersInfo.showOrgs ? (
                          <td style={u.isDisabled ? {"color": "#666", "textDecoration": "line-through"} : {}}>{u.customer_name}</td>
                        ) : ("") }
                        <td style={u.isDisabled ? {"color": "#666", "textDecoration": "line-through"} : {}}>{u.name}</td>
                        <td style={u.isDisabled ? {"color": "#666", "textDecoration": "line-through"} : {}}>{u.email}</td>
                        <td>{u.lastSeen}</td>
                        <td>
                            {u.id != usersInfo.id ? (u.isDisabled ? (<>
                                <button onClick={(e) => { u.do_enable(); forceUpdate(); }} style={{marginRight: "5px"}}>Enable</button>
                                <button onClick={(e) => { u.do_delete().then((_r)=>{ api.fetch_managable_users().then(setUsers); }); }}>Delete</button>
                              </>) : (<>
                                <button onClick={(e) => { u.do_password_reset().then((r)=> { if(r.errors) { alert(r.errors[0]); } else { alert("Email Sent"); } }); }}>Reset PW</button>
                                <button onClick={(e) => { u.do_disable(); forceUpdate(); }} style={{marginLeft: "5px"}}>Disable</button>
                              </>)) : ""
                            }
                        </td>
                        </tr>
                    ))
                )}
                </tbody>
            </Table>
            </>
        }
        />
          <Modal show={showCreateModal} onHide={() => { setShowCreateModal(false); setNewUserInfo({}) }}>
            <Modal.Header closeButton>
              <Modal.Title>Create User</Modal.Title>
              <Modal.Body>
                <form onSubmit={handleCreateUser} method={"POST"}>
                  <FormGroup>
                    <ControlLabel>Name</ControlLabel>
                    <FormControl name="name" placeholder="Name" type="text" onChange={(e)=>setNewUserInfo({...newUserInfo, name: e.target.value})} />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Email address</ControlLabel>
                    <FormControl name="email" placeholder="Email Address" type="email" onChange={(e)=>setNewUserInfo({...newUserInfo, email: e.target.value})} />
                  </FormGroup>
                  {usersInfo.showOrgs ? (
                    <FormGroup>
                      <ControlLabel>Org</ControlLabel>
                      <FormControl name="orgId" componentClass="select" onChange={(e)=>setNewUserInfo({...newUserInfo, orgId: e.target.value})}>
                        {usersInfo.orgs.map((org)=>(<option value={org.id}>{org.name}</option>))}  
                      </FormControl>
                    </FormGroup>
                  ) : ("")}
                  <input type="submit" style={{ "display": "none" }} />
                  { newUserInfo.warning ? (<div class="text-danger">{newUserInfo.warning}</div>) : ("") }
                </form>
              </Modal.Body>
            </Modal.Header>
            <Modal.Footer>
              <Button simple onClick={(e) => { setShowCreateModal(false); setNewUserInfo({}) }}>Cancel</Button>
              <Button simple onClick={(e) => { if(!showLoading) { handleCreateUser(e); } else { e.preventDefault(); } }} disabled={showLoading}>Create</Button>
            </Modal.Footer>
          </Modal>
    </div>
  );
};

export default UserMgmt;
